import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
// 相关材料list
  findApplication({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/findApplication`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 相关材料 推送回执
  saveStudentApplication({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/saveStudentApplication`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  upMaterialis({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/upMaterialis`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 相关材料 推送回执
  findStudentUpload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/findStudentUpload`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 相关材料 审核推送回执
  approalStart({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/approalStart`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  applicationInfo({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/applicationInfo`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  applicationStart({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`application/applicationStart`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  upload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`file/upload`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findRecommendationAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/findRecommendationAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findApplicationManualAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/findApplicationManualAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findEntryScreenshotsAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/findEntryScreenshotsAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  pushBaomingPhoto({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/pushBaomingPhoto`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delBaomingPhoto({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/delBaomingPhoto`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertEntryScreenshotsAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/insertEntryScreenshotsAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findOneBaoming({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/findOneBaoming`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findHmtInterviewTrainingAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/findHmtInterviewTrainingAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findNoticeList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/findNoticeList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  insertHmtInterviewTrainingAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertHmtInterviewTrainingAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delNotice({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/delNotice`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertHmtInterviewTraining({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertHmtInterviewTraining`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findHmtTrainVideoAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/findHmtTrainVideoAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  selectVideoIdList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/selectVideoIdList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  lookSchoolVideo({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/lookSchoolVideo`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertHmtTrainVideoList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertHmtTrainVideoList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findHmtVisaTemplateAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/findHmtVisaTemplateAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertEventActivitiesList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertEventActivitiesList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertEventActivities({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertEventActivities`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insertNotice({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`analysisOfCollegeInterview/insertNotice`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  checkStringCode({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`academicPlanning/checkStringCode`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

// editReportState({commit}, params) {
//   return new Promise((resolve, reject) => {
//     axios.post(`selfAndHmtEvaluation/editReportState`, params)
//       .then(response => {
//         resolve(response)
//       })
//       .catch(error => {
//         reject(error)
//       })
//   })
// },
  // editReportState({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'post',
  //       url: '/selfAndHmtEvaluation/editReportState',
  //       params: params,
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).then(response => {
  //       resolve(response)
  //     }).catch((error) => {
  //       reject(error)
  //     })
  //   })
  // },
  findAgreeUniversity({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/findAgreeUniversity`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUniversityStatus({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`onlineApplicationService/updateUniversityStatus`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
